import * as Yup from "yup";
import { NormalizedOriginProject } from "slices/originProjects/originProjectState";

export type ProjectFormData = {
  project?: NormalizedOriginProject | null;
};
export const originProjectFormData: ProjectFormData = {};
export const projectViewModelSchema = Yup.object().shape({
  project: Yup.object().required("*Dataset is a required field").nullable(),
});
